// src/components/dashboard/cases/newCase/case_id/Production.js
// OPTIMIZED: caseData prop se data leta hai, API hit nahi karta

import React from 'react';
import { format } from 'date-fns';

const Production = ({ caseId, caseData }) => {
  if (!caseData) return <div>Loading...</div>;

  const creationDate = caseData?.createdAt
    ? format(new Date(caseData.createdAt), 'dd MMM yyyy HH:mm:ss')
    : 'N/A';

  const lastUpdatedDate = caseData?.updatedAt
    ? format(new Date(caseData.updatedAt), 'dd MMM yyyy HH:mm:ss')
    : 'N/A';

  const sendToLabDate = caseData?.date
    ? format(new Date(caseData.date), 'dd MMM yyyy')
    : 'N/A';

  return (
    <div
      style={{
        padding: '0',
        margin: '0',
        fontFamily: '"Times New Roman", Times, serif',
        color: '#000',
        textAlign: 'left',
      }}
    >
      <h1
        style={{
          fontSize: '32px',
          fontWeight: '400',
          margin: '0 0 25px 0',
          padding: '0',
          fontFamily: '"Times New Roman", Times, serif',
          textAlign: 'left',
        }}
      >
        Production
      </h1>

      <div style={{ margin: '0 0 20px 0', padding: '0', textAlign: 'left' }}>
        <div style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 0 4px 0', padding: '0' }}>
          Creation Date:
        </div>
        <div style={{ fontSize: '17px', fontWeight: '400', margin: '0', padding: '0' }}>
          {creationDate}
        </div>
      </div>

      <div style={{ margin: '0 0 20px 0', padding: '0', textAlign: 'left' }}>
        <div style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 0 4px 0', padding: '0' }}>
          Last Updated:
        </div>
        <div style={{ fontSize: '17px', fontWeight: '400', margin: '0', padding: '0' }}>
          {lastUpdatedDate}
        </div>
      </div>

      <div style={{ margin: '0 0 20px 0', padding: '0', textAlign: 'left' }}>
        <div style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 0 4px 0', padding: '0' }}>
          Send to Lab Date:
        </div>
        <div style={{ fontSize: '17px', fontWeight: '400', margin: '0', padding: '0' }}>
          {sendToLabDate}
        </div>
      </div>
    </div>
  );
};

export default Production;